import type { IOpeningHour } from '../interfaces'

const MONTAG = Date.UTC(2024, 0, 1) // 2024-01-01 ist ein Montag

export const resolveViewerLocale = (): string =>
  (typeof navigator !== 'undefined' && navigator.language) || 'de-DE'

export function weekdayShort(day: number, locale: string = resolveViewerLocale()): string {
  return new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' })
    .format(new Date(MONTAG + (day - 1) * 86_400_000)).replace(/\.$/, '')
}

export function groupOpeningHours(hours: IOpeningHour[] = []) {
  const byDay = new Map<number, { open: string; close: string }[]>()
  for (const h of hours) {
    const day = h.open?.day
    if (!day || !h.close?.time) continue
    const list = byDay.get(day) ?? []
    list.push({ open: h.open.time, close: h.close.time })
    byDay.set(day, list)
  }
  return [...byDay.entries()].sort(([a], [b]) => a - b)
    .map(([day, slots]) => ({ day, slots: slots.sort((a, b) => a.open.localeCompare(b.open)) }))
}
